import { Divider, Typography } from "antd"
import { ManyTargetCampaignsHistory } from "../../manyTargetsCampaignsHistory"
import SkcHistory from "./SkcHistory"

const SpHistory: React.FC = () => {
  return (
    <>
      <Typography.Title level={5}>SP SKC</Typography.Title>
      <SkcHistory />

      <Divider />

      <Typography.Title level={5}>SP Targets</Typography.Title>
      <ManyTargetCampaignsHistory />
    </>
  )
}

export default SpHistory
